module.exports = __webpack_public_path__ + "static/media/header_star.a1d381e9.gif";